import { Component, ViewChild } from '@angular/core';
import { ListTeamComponent } from 'components/admin/team/list-team.component';
import { ButtonComponent } from 'components/input/button/button.component';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { InputStateDirective } from 'directives/input-state.directive';
import { InputType } from 'enums/InputType';
import { TeamModel } from 'models/generated/Identity.Api.Models.Team';
import { UserTeamModel } from 'models/generated/Identity.Api.Models.UserTeam';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { ViewTeamCredentialsComponent } from './view-team-credentials.component';
import { BrandService } from 'services/brand.service';
import { SelectListItemModel } from 'models/SelectList';

@Component({
	selector: 'view-team',
	templateUrl: './view-team.component.html',
	imports: [Layout, CustomSelectComponent, CustomInputComponent, ListView, InputStateDirective, ViewTeamCredentialsComponent, TranslatePipe]
})
@ComponentUrl('view-team')
export class ViewTeamComponent {

	@ViewChild('saveButton') saveButton!: ButtonComponent;

	public team?: TeamModel;
	public users: { id: string, name: string, selected: boolean, wasSelected: boolean }[] = [];
	inputType = InputType;
	brands: SelectListItemModel[] = [];

	private _teamId?: string;
	@UrlParam
	set teamId(id: string | undefined) {
		this._teamId = id;
		if (id) {
			this.userService.getTeamById(id).then(team => {
				this.loadTeamModel(team);
			});
		} else {
			this.loadTeamModel(new TeamModel());
		}
		this.navigation.openParentView(this, 'view-Team', ListTeamComponent).then(list => {
			list.highlightedTeamId = id;
			list.activeTeamView = this;
		});
	}
	get teamId() {
		return this._teamId;
	}

	constructor(private readonly navigation: NavigationService, private readonly userService: UserService, private readonly brandService: BrandService) {
		this.brandService.brands.forEach(brand => {
			this.brands.push(new SelectListItemModel(brand.id!, brand.name));
		});
	}

	loadTeamModel(team: TeamModel) {
		this.userService.getAllActiveUsers().then(users => {
			users.sort((a, b) => a.name.localeCompare(b.name));

			this.users = users.map(user => { return { id: user.id!, name: user.name, selected: team.userTeams.some(ut => ut.userId == user.id), wasSelected: team.userTeams.some(ut => ut.userId == user.id) } });
			this.team = team;

			this.navigation.refreshUrl();
		});
	}

	canSave() {
		if (!this.team) return;
		return this.team.name.length > 0 && (!this.team.sale || (this.team.sale && this.team.salesBrandId != undefined))
	}

	save() {
		if (!this.team) return;
		let selectedUserTeams = this.users.filter(user => user.selected).map(user => {
			let userTeam = this.team?.userTeams.find(ut => ut.userId == user.id) ?? new UserTeamModel();
			userTeam.teamId = this.team!.id;
			userTeam.userId = user.id;
			return userTeam;
		});
		this.team.salesBrandId = this.team.sale ? this.team.salesBrandId : undefined;
		this.team.userTeams = selectedUserTeams;
		this.team.include(t => t.userTeams);
		if (this.team.id != undefined)
			this.userService.updateTeam(this.team).then(() => { this.saveButton.succeeded(); });
		else
			this.userService.createTeam(this.team).then(team => { this.navigation.refreshView(ViewTeamComponent).then(view => view.teamId = team.id) });
	}
}
